module.exports = __webpack_public_path__ + "media/images/plans/plan-detail-icon-move-68a67b8f6e57a2ff66604afa860fb8e9.png";